import React from "react";
import { OwcHorizontalStep, OwcHorizontalStepper, OwcIcon, OwcTooltip } from "@one/react";
import { ClusterStepType, formTypes, FormTypesRestricted } from "../../../constants";
import { react18WorkaroundProps } from "../../../utils/constants/react18WorkaroundProps";
interface FormStepsProps {
  stepsArray: ClusterStepType[];
  activeStep: ClusterStepType;
  handleClick: (step: ClusterStepType) => void;
  isEditMode?: boolean;
  type: FormTypesRestricted;
}

const FormSteps = ({ stepsArray, activeStep, handleClick, isEditMode = false, type }: FormStepsProps) => {
  return (
    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <OwcHorizontalStepper
        data-testid="booking-calendar-stepper-element-box"
        activeStep={activeStep.id}
        style={{
          width: type === formTypes.RUN_LOG ? "50%" : "73%",
          margin: "15px 0 14px 0",
          minWidth: "fit-content"
        }}
        {...react18WorkaroundProps}
      >
        {stepsArray.map((label, index) => {
          if (isEditMode && label.id === 1) {
            label.description = "Update equipment";
          }
          const labelProps = {
            completed: label.completed,
            error: label.error,
            active: label.active,
            cursor: label.cursor
          };

          return (
            <OwcHorizontalStep
              key={index}
              data-testid={`booking-calendar-stepper-element-step`}
              onClick={() => {
                handleClick(label);
              }}
              style={{ cursor: isEditMode ? "pointer" : "default" }}
              {...labelProps}
              {...react18WorkaroundProps}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <div style={{ paddingRight: "10px" }}>{label.description}</div>
                <div>
                  <OwcIcon
                    id={`tooltip-trigger-${type}-${label.id}`}
                    name="circle_help"
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  />
                  <OwcTooltip
                    anchor={`tooltip-trigger-${type}-${label.id}`}
                    placement="right"
                    placeholder={undefined}
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  >
                    {label.tooltip}
                  </OwcTooltip>
                </div>
              </div>
            </OwcHorizontalStep>
          );
        })}
      </OwcHorizontalStepper>
    </div>
  );
};

export default FormSteps;
